<app-dt-card class="cron-comandos">
  <!-- ── header ─────────────────────────────────────────────── -->
  <div class="cc-header">
    <h3 class="dt-titulo cc-title">
      <mat-icon>send</mat-icon>
      Cronología de comandos manuales
      @if (cargando()) {
        <mat-progress-spinner
          diameter="16"
          mode="indeterminate"
        ></mat-progress-spinner>
      }
    </h3>
    <button
      irxBotonIcono
      type="button"
      (click)="toggleAyuda()"
      tooltip="¿Qué significan los estados y los colores?"
      [activo]="mostrarAyuda()"
    >
      <mat-icon>help_outline</mat-icon>
    </button>
  </div>

  <!-- ── panel de ayuda ─────────────────────────────────────── -->
  @if (mostrarAyuda()) {
    <div class="cc-ayuda">
      <div class="cc-ayuda-col">
        <h4>Estado en la fila (transporte)</h4>
        @for (g of estadosCola; track g.estado) {
          <div class="cc-ayuda-item">
            <span class="cc-chip {{ g.clase }}">{{ g.estado }}</span>
            <span class="cc-ayuda-desc">{{ g.desc }}</span>
          </div>
        }
      </div>
      <div class="cc-ayuda-col">
        <h4>Estado en el dispositivo</h4>
        @for (g of estadosDispositivo; track g.estado) {
          <div class="cc-ayuda-item">
            <span class="cc-chip {{ g.clase }}">{{ g.estado }}</span>
            <span class="cc-ayuda-desc">{{ g.desc }}</span>
          </div>
        }
      </div>
    </div>
  }

  <!-- ── vacío ──────────────────────────────────────────────── -->
  @if (!cargando() && !items().length) {
    <div class="cc-vacio">
      <mat-icon>inbox</mat-icon>
      <span>No hay comandos manuales para esta luminaria.</span>
    </div>
  }

  <!-- ── línea de tiempo ────────────────────────────────────── -->
  <div class="cc-timeline">
    @for (it of itemsVisibles(); track trackItem($index, it)) {
      <div class="cc-item" [class.cc-onoff]="it.esOnOff">
        <!-- nodo -->
        <div class="cc-nodo {{ estadoClase(it.job.estado) }}">
          <mat-icon>{{ accionIcono(it.job.nombre) }}</mat-icon>
        </div>

        <!-- cuerpo -->
        <div class="cc-body">
          <div class="cc-linea1">
            <span class="cc-accion">{{ it.accion }}</span>
            <!-- nivel de origen -->
            <span
              class="cc-nivel"
              matTooltip="Enviado desde: {{
                nivelLabel(it.job.objetivo?.nivel)
              }}{{
                it.job.objetivo?.nombre ? ' · ' + it.job.objetivo?.nombre : ''
              }}"
            >
              <mat-icon>{{ nivelIcono(it.job.objetivo?.nivel) }}</mat-icon>
              {{ nivelLabel(it.job.objetivo?.nivel) }}
              @if (it.job.objetivo?.nombre) {
                <b>· {{ it.job.objetivo?.nombre }}</b>
              }
            </span>
            <span class="cc-fecha">
              {{ it.job.fechaCreacion | date: 'dd/MM/yyyy HH:mm:ss' }}
            </span>
          </div>

          <div class="cc-linea2">
            <!-- estado cola -->
            <span
              class="cc-chip {{ estadoClase(it.job.estado) }}"
              matTooltip="Estado en la fila (transporte)"
            >
              <mat-icon>{{ estadoIcono(it.job.estado) }}</mat-icon>
              {{ estadoLabel(it.job.estado) }}
            </span>
            <mat-icon class="cc-flecha">arrow_forward</mat-icon>
            <!-- estado dispositivo -->
            <span
              class="cc-chip {{ comandoClase(it.comando?.estado) }}"
              matTooltip="Estado en el dispositivo"
            >
              @if (it.comando?.estado) {
                <mat-icon>{{ comandoIcono(it.comando?.estado) }}</mat-icon>
              }
              {{ comandoLabel(it.comando?.estado) }}
            </span>

            <!-- puerto / payload -->
            <span class="cc-meta" matTooltip="Puerto y payload enviado (hex)">
              pto {{ it.job.puerto }} · <code>{{ it.job.payload }}</code>
            </span>

            <!-- reintentos -->
            @if (it.job.intentos > 1 || tieneIntentos(it.job)) {
              <button
                class="irx-chip irx-chip--compacto"
                type="button"
                [attr.aria-pressed]="intentosAbierto(it.job._id)"
                (click)="toggleIntentos(it.job._id)"
                tooltip="Ver intentos de envío"
              >
                <mat-icon>refresh</mat-icon>
                {{ it.job.intentos }} intento{{
                  it.job.intentos === 1 ? '' : 's'
                }}
                <mat-icon>
                  {{
                    intentosAbierto(it.job._id) ? 'expand_less' : 'expand_more'
                  }}
                </mat-icon>
              </button>
            }
          </div>

          <!-- fechas de transición -->
          <div class="cc-fechas">
            <span matTooltip="Creado / en fila">
              <mat-icon>add</mat-icon>
              {{ it.job.fechaCreacion | date: 'dd/MM/yyyy HH:mm:ss' }}
            </span>
            @if (it.job.fechaProgramada) {
              <span matTooltip="Reprogramado (delay)">
                <mat-icon>event</mat-icon>
                {{ it.job.fechaProgramada | date: 'dd/MM/yyyy HH:mm:ss' }}
              </span>
            }
            @if (it.job.fechaEnviado) {
              <span matTooltip="Enviado a Chirpstack/NS">
                <mat-icon>send</mat-icon>
                {{ it.job.fechaEnviado | date: 'dd/MM/yyyy HH:mm:ss' }}
              </span>
            }
            @if (it.job.fechaConfirmado) {
              <span matTooltip="Confirmado">
                <mat-icon>check_circle</mat-icon>
                {{ it.job.fechaConfirmado | date: 'dd/MM/yyyy HH:mm:ss' }}
              </span>
            }
          </div>

          <!-- último error -->
          @if (it.job.ultimoError) {
            <div class="cc-error">
              <mat-icon>error</mat-icon>
              {{ it.job.ultimoError }}
            </div>
          }

          <!-- detalle de intentos -->
          @if (intentosAbierto(it.job._id)) {
            <div class="cc-intentos">
              @for (int of intentos(it.job); track int.numero) {
                <div class="cc-intento {{ intentoClase(int.resultado) }}">
                  <mat-icon>{{ intentoIcono(int.resultado) }}</mat-icon>
                  <span class="cc-int-num">#{{ int.numero }}</span>
                  <span class="cc-int-res">{{ int.resultado }}</span>
                  <span class="cc-int-fecha">
                    {{ int.fecha | date: 'dd/MM/yyyy HH:mm:ss' }}
                  </span>
                  @if (int.error) {
                    <span class="cc-int-error">{{ int.error }}</span>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>

  <!-- ── paginación ─────────────────────────────────────────── -->
  @if (restantes() > 0 || hayExpandidos()) {
    <div class="cc-paginacion">
      @if (restantes() > 0) {
        <button irxBoton="texto" type="button" (click)="mostrarMas()">
          <mat-icon>expand_more</mat-icon>
          Mostrar más ({{ restantes() }})
        </button>
      }
      @if (hayExpandidos()) {
        <button irxBoton="texto" type="button" (click)="mostrarMenos()">
          <mat-icon>expand_less</mat-icon>
          Mostrar menos
        </button>
      }
    </div>
  }
</app-dt-card>
